export const state = {
  expenses: [],
  expense_item: [
    {
      truck_id: "",
      expense_description: "",
      expense_measurement: "",
      qty: "",
      unit_price: "",
      total_price: "",
      remarks: ""
    }
  ]
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/expenses/state.js